module.exports = __webpack_public_path__ + "static/media/23_plantilla_combo_cuadrada_marco_comida_58.d1061ca8.png";